module.exports = __webpack_public_path__ + "img/juhan_mp.c1cbedd8.jpg";